import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import Formsy from "formsy-react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { TextInput } from "../Shared/Forms";
import { Spinner } from "../Shared";

import { cardSchemeActions } from "./actions/cardschemes.actions";
import { routeConstants } from "../../_constants";

export class CardSchemeForm extends Component {
  state = {
    canSubmit: false
  };

  componentDidMount() {
    this.getCardScheme();
  }

  componentWillUnmount() {
    this.props.resetCardScheme();
  }

  getCardScheme = () => {
    const { match } = this.props;
    if (match.params && match.params.id) {
      this.props.getCardScheme(match.params.id);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.submitted) {
      this.refs.cardSchemeForm.reset();
    }
  }

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  handleSubmit = data => {
    const { match } = this.props;
    const hasParams = match.params && match.params.id;
    if (hasParams) {
      data = {
        id: match.params.id,
        ...data
      };
    }
    this.props.addCardScheme(data);
  };

  render() {
    const { canSubmit } = this.state;
    const { submitting, match, viewResponse, viewError, fetched } = this.props;
    const cardScheme =
      viewResponse && fetched ? viewResponse.modelList[0] : null;
    const hasParams = match.params && match.params.id;
    return (
      <div>
        <Row>
          <Col sm="6">
            <Link className="btn btn-outline btn-primary" to={routeConstants.CARDSCHEMES.path}>
              <MdArrowBack /> Back to list
            </Link>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <h5 className="item-count">
                {hasParams ? "Edit" : "Add"} Card Scheme
                <small>
                  {cardScheme && hasParams ? `: ${cardScheme.code}` : null}
                </small>
              </h5>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col sm="4">
            {viewError ? (
              <Alert color="danger">
                <strong>Error:</strong> {viewError.message}
              </Alert>
            ) : (
              <Formsy
                ref="cardSchemeForm"
                onValidSubmit={this.handleSubmit}
                onValid={this.enableButton}
                onInvalid={this.disableButton}
                noValidate
              >
                <TextInput
                  name="code"
                  value={cardScheme && hasParams ? cardScheme.code : null}
                  required
                  disabled={submitting || hasParams}
                  title="Card scheme code"
                />
                <TextInput
                  name="description"
                  value={cardScheme && hasParams ? cardScheme.description : null}
                  required
                  disabled={submitting}
                  title="Card scheme description"
                />
                <Button
                  type="submit"
                  color="primary"
                  disabled={!canSubmit || submitting}
                >
                  {submitting ? <Spinner /> : "Submit"}
                </Button>
              </Formsy>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    submitting,
    submitted,
    request,
    response,
    error
  } = state.addCardScheme;

  const {
    fetching,
    fetched,
    request: viewRequest,
    response: viewResponse,
    error: viewError
  } = state.viewCardScheme;

  return {
    submitting,
    submitted,
    request,
    response,
    error,
    fetching,
    fetched,
    viewRequest,
    viewResponse,
    viewError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addCardScheme: bindActionCreators(
      cardSchemeActions.addCardScheme,
      dispatch
    ),
    resetCardScheme: bindActionCreators(
      cardSchemeActions.resetCardScheme,
      dispatch
    ),
    getCardScheme: bindActionCreators(cardSchemeActions.getCardScheme, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CardSchemeForm);
